import React, { useState } from 'react';
import { X, Check, ShieldCheck, AlertCircle } from 'lucide-react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const FileAcknowledgmentModal = ({ file, onClose, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [hasScrolled, setHasScrolled] = useState(false); // In a real app, track if they scrolled the content

    const handleAcknowledge = async () => {
        try {
            setLoading(true);
            await api.post(`/files/acknowledge/${file.id}`, {});
            toast.success('File marked as reviewed');
            onSuccess?.(); // Callback to refresh status
            onClose();
        } catch (error) {
            console.error('Acknowledgement error:', error);
            toast.error(error.response?.data?.message || 'Failed to acknowledge file');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl border border-gray-100 overflow-hidden transform transition-all animate-in fade-in zoom-in-95 duration-200">

                {/* Header */}
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-6 text-white text-center">
                    <div className="mx-auto w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-3 backdrop-blur-sm">
                        <ShieldCheck size={28} />
                    </div>
                    <h2 className="text-xl font-bold mb-1">Acknowledge Policy</h2>
                    <p className="text-blue-100 text-sm">Please confirm you have reviewed this document.</p>
                </div>

                {/* Content */}
                <div className="p-6">
                    <div className="bg-gray-50 rounded-xl p-4 mb-6 border border-gray-100">
                        <div className="flex items-center gap-3 mb-2">
                            <div className="p-2 bg-white rounded-lg border border-gray-100 shadow-sm">
                                <AlertCircle size={20} className="text-blue-600" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-900 truncate max-w-[200px]">{file.file_name}</h3>
                                <p className="text-xs text-gray-500">Version {file.version_number || '1.0'}</p>
                            </div>
                        </div>
                    </div>

                    <p className="text-gray-600 text-sm leading-relaxed mb-6 text-center">
                        By clicking "I Acknowledge", you confirm that you have read, understood, and agree to the contents of this document. This action will be recorded.
                    </p>

                    <div className="flex gap-3">
                        <button
                            onClick={onClose}
                            className="flex-1 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-medium transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleAcknowledge}
                            disabled={loading}
                            className="flex-1 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-medium transition-all shadow-lg shadow-blue-600/20 disabled:opacity-50 flex items-center justify-center gap-2"
                        >
                            {loading ? (
                                <>Processing...</>
                            ) : (
                                <>
                                    <Check size={18} />
                                    I Acknowledge
                                </>
                            )}
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default FileAcknowledgmentModal;
